import { computed } from 'mobx';

import { factory, OData, $data } from 'src/core/services/data/JayDataContext';
import { ContextService } from 'src/core/services/context.service';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { FormatService } from 'src/core/services/format.service';
import { EntityModel } from 'src/core/services/data/models';

export class ContractRangeDateListDataService extends DataService<typeof Model.Products.Logic.ViewModels.ContractRangeDateItem, Model.Products.Logic.ViewModels.ContractRangeDateItem, ContractRangeDateItem> {
    private id = -1;

    constructor(contextService: ContextService, entitySet: (context: OData.Container) => $data.EntitySet<typeof Model.Products.Logic.ViewModels.ContractRangeDateItem, Model.Products.Logic.ViewModels.ContractRangeDateItem>, private formatService: FormatService) {
        super(contextService, entitySet);
    }

    protected map(entity: Model.Products.Logic.ViewModels.ContractRangeDateItem): ContractRangeDateItem {
        return new ContractRangeDateItemModel(entity, this.formatService);
    }

    static make(context?: any, formatService?: FormatService): ContractRangeDateListDataService {
        return new ContractRangeDateListDataService(context, ctx => ctx.ContractRangeDates, formatService);
    }

    add(bookingDateFrom: Date, bookingDateTo: Date, serviceDateFrom: Date, serviceDateTo: Date, idContract: number) {
        const entity = new Model.Products.Logic.ViewModels.ContractRangeDateItem();
        entity.bookingDateFrom = bookingDateFrom;
        entity.bookingDateTo = bookingDateTo;
        entity.serviceDateFrom = serviceDateFrom;
		entity.serviceDateTo = serviceDateTo;
		entity.contractId = idContract;
        entity.id = --this.id;

        return entity;
    }

    clone(contractRangeDateItem: ContractRangeDateItem) {
        const entity = new Model.Products.Logic.ViewModels.ContractRangeDateItem();
        entity.bookingDateFrom = contractRangeDateItem. bookingDateFrom;
        entity.bookingDateTo = contractRangeDateItem.bookingDateTo;
        entity.serviceDateFrom = contractRangeDateItem. serviceDateFrom;
        entity.serviceDateTo = contractRangeDateItem.serviceDateTo;
        entity.contractId = contractRangeDateItem.contractId;
		entity.id = (contractRangeDateItem.id > 0) ? contractRangeDateItem.id * -1 : contractRangeDateItem.id - 100;

        return entity;
    }
}

export class ContractRangeDateItemModel extends EntityModel<Model.Products.Logic.ViewModels.ContractRangeDateItem, ContractRangeDateItem> implements ContractRangeDateItem {
    @property<ContractRangeDateItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<ContractRangeDateItemModel>(o => o.entity.bookingDateFrom, (o, value) => o.entity.bookingDateFrom = value)
    public bookingDateFrom: Date;

    @property<ContractRangeDateItemModel>(o => o.entity.bookingDateTo, (o, value) => o.entity.bookingDateTo = value)
    public bookingDateTo: Date;

    @property<ContractRangeDateItemModel>(o => o.entity.contractId, (o, value) => o.entity.contractId = value)
    public contractId: number;

    @computed
	public get bookingDateFromText(): string {
		return this.formatService.toString('short-date', this.bookingDateFrom, "utc");
    }

    @computed
    public get bookingDateToText(): string {
		return this.formatService.toString('short-date', this.bookingDateTo, "utc");
    }

    @property<ContractRangeDateItemModel>(o => o.entity.serviceDateFrom, (o, value) => o.entity.serviceDateFrom = value)
    public serviceDateFrom: Date;

    @computed
    public get serviceDateFromText(): string {
		return this.formatService.toString('short-date', this.serviceDateFrom, "utc");
    }

    @property<ContractRangeDateItemModel>(o => o.entity.serviceDateTo, (o, value) => o.entity.serviceDateTo = value)
    public serviceDateTo: Date;

    @computed
    public get serviceDateToText(): string {
		return this.formatService.toString('short-date', this.serviceDateTo, "utc");
    }

    constructor(entity: Model.Products.Logic.ViewModels.ContractRangeDateItem, private formatService: FormatService) {
        super(entity);
    }
}



// WEBPACK FOOTER //
// ./src/app/products/contract/form/contract-range-date.data.ts